(function() {
  'use strict';

  // Prevents the script from running if the element is already defined
  if (customElements.get('quantity-counter')) {
    
    return;
  }

  class QuantityCounter extends HTMLElement {
    constructor() {
      super();
      
    }

    connectedCallback() {
      
      this.input = this.querySelector('input');

      if (!this.input) {
        
        return;
      }

      this.changeEvent = new Event('change', { bubbles: true });
      this.buttonClickEvent = this.onButtonClick.bind(this);
      this.onQuantityChangeEvent = this.onQuantityChange.bind(this);

      this.input.addEventListener('change', this.onQuantityChangeEvent);
      this.querySelectorAll('button').forEach(button => {
        button.addEventListener('click', this.buttonClickEvent);
      });

      
    }

    disconnectedCallback() {
      // This component was removed from the DOM.
      
    }

    onButtonClick(event) {
      event.preventDefault();
      

      const originalValue = this.input.value;
      const button = event.target.nodeName === 'BUTTON' ? event.target : event.target.closest('button');

      if (button.name === 'increase') {
        this.input.stepUp();
      } else if (button.name === 'decrease') {
        this.input.stepDown();
      }

      if (originalValue !== this.input.value) {
        
        // this.input.dispatchEvent(this.changeEvent); // <-- Temporarily comment this line out
      }
    }

    onQuantityChange() {
      
      // if (this.input.name === 'updates[]') {
      //   this.updateCart();
      // }
    }

    updateCart() {
      if (this.input.value !== '') {
        
        this.dispatchEvent(new CustomEvent('theme:cart:update', {
          bubbles: true,
          detail: {
            id: this.input.dataset.id,
            quantity: this.input.value
          }
        }));
      }
    }
  }

  customElements.define('quantity-counter', QuantityCounter);
  

})();
